//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UiLinkSocialImg',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
